import { ReportOpts, onCLS, onFCP, onINP, onLCP, onTTFB, onFID } from 'web-vitals';

const reportWebVitals = async (onPerfEntry?: ReportOpts) => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    onCLS(onPerfEntry);
    onFID(onPerfEntry);
    onFCP(onPerfEntry);
    onLCP(onPerfEntry);
    onTTFB(onPerfEntry);
  }
};

export default reportWebVitals;
